// pages/UserAdmin/crm/MenuCrm.js — o menu suspenso do CRM (out/26).
//
// Um só desenho pra todos os menus da tela, como no Claude Design "CRM
// Moderno": cartão de raio 16, título em caixa-alta e itens de 40px com
// bolinha (interesse, etiqueta), pasta colorida ou nada, e o ✓ à direita no
// que está marcado. Antes cada menu tinha o próprio tamanho de fonte e o
// próprio jeito de marcar.
//
// Por baixo é o Menu do MUI: foco, setas do teclado, Esc e clique fora
// continuam de graça. Os menus da barra de lote abrem pra CIMA (`acima`),
// porque a barra fica colada no rodapé.

import { Box, Divider, ListSubheader, Menu, MenuItem } from '@mui/material';
import { Icon } from './icons';
import { OUTFIT, rotulo } from './theme';

export function MenuCrm({ anchorEl, onClose, titulo, acima = false, largura = 232, children, acaoTitulo }) {
  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{ vertical: acima ? 'top' : 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: acima ? 'bottom' : 'top', horizontal: 'left' }}
      slotProps={{
        paper: {
          sx: {
            mt: acima ? -1 : 0.75, minWidth: largura, maxHeight: 360, p: '6px',
            bgcolor: 'var(--ch-card)', color: 'var(--ch-text)', fontFamily: OUTFIT,
          },
        },
        list: { sx: { p: 0 } },
      }}
    >
      {titulo && (
        <ListSubheader disableSticky sx={{ ...rotulo, display: 'flex', alignItems: 'center', gap: 1, p: '8px 10px 6px', lineHeight: 1.4, bgcolor: 'transparent' }}>
          <Box component="span" sx={{ flex: 1 }}>{titulo}</Box>
          {acaoTitulo}
        </ListSubheader>
      )}
      {children}
    </Menu>
  );
}

/**
 * @param ponto     cor da bolinha (interesse, etiqueta)
 * @param tracejado bolinha tracejada ("Não classificado")
 * @param pasta     cor do ícone de pasta
 * @param icone     ícone qualquer à esquerda
 * @param marcado   mostra o ✓ verde
 * @param apagado   texto em cor de legenda ("Sem responsável", "Desatribuir")
 * @param perigo    texto vermelho ("Apagar pasta")
 * @param fim       algo extra à direita (o ⋯ das pastas)
 */
export function ItemMenu({ onClick, ponto, tracejado, pasta, icone, marcado, apagado, perigo, disabled, fim, children }) {
  return (
    <MenuItem
      onClick={onClick}
      disabled={disabled}
      sx={{
        minHeight: 40, gap: 1.25, px: 1.25, borderRadius: '10px', fontFamily: OUTFIT, fontSize: 14.5, fontWeight: 500,
        color: perigo ? 'var(--ch-red-d)' : apagado ? 'var(--cx-cap)' : 'var(--ch-text)',
        '&:hover': { bgcolor: perigo ? 'var(--ch-red-bg)' : 'var(--ch-inset)' },
        '&.Mui-focusVisible': { bgcolor: 'var(--ch-inset)' },
        '&:hover .cx-fim, &.Mui-focusVisible .cx-fim': { opacity: 1 },
      }}
    >
      {(ponto || tracejado) && (
        <Box component="span" sx={{
          width: 9, height: 9, borderRadius: '50%', flexShrink: 0,
          bgcolor: tracejado ? 'transparent' : ponto, border: tracejado ? '1.5px dashed var(--cx-cap)' : 0,
        }} />
      )}
      {pasta && <Box component="span" sx={{ display: 'flex', color: pasta, flexShrink: 0 }}><Icon.Folder size={15} /></Box>}
      {icone && <Box component="span" sx={{ display: 'flex', flexShrink: 0, color: perigo ? 'inherit' : 'var(--cx-cap)' }}>{icone}</Box>}
      <Box component="span" sx={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {children}
      </Box>
      {marcado && <Box component="span" sx={{ display: 'flex', color: 'var(--ch-green)', flexShrink: 0 }}><Icon.Check size={15} strokeWidth={2.4} /></Box>}
      {fim && <Box component="span" className="cx-fim" sx={{ display: 'flex', opacity: 0, transition: 'opacity .15s', '@media (hover: none)': { opacity: 1 } }}>{fim}</Box>}
    </MenuItem>
  );
}

export function DivisorMenu() {
  return <Divider sx={{ borderColor: 'var(--ch-bdr)', my: '6px !important', mx: '6px' }} />;
}

export function NotaMenu({ children }) {
  return (
    <ListSubheader disableSticky sx={{ p: '8px 10px', fontFamily: OUTFIT, fontSize: 13, fontWeight: 400, lineHeight: 1.45, color: 'var(--cx-cap)', maxWidth: 260, bgcolor: 'transparent' }}>
      {children}
    </ListSubheader>
  );
}
